import { IChangePasswordValues } from 'interfaces/Profile/IChangePasswordValues';
import { useCallback } from 'react';
import { profileRoute } from '../../helpers/apiRoutes';
import { useApiCalls } from '../UseApiCalls';

export const ProfileApis = () => {
  const { postQuery, getQuery } = useApiCalls();

  const postChangePassword = useCallback(
    (id: number, data: IChangePasswordValues) => {
      return postQuery(`${profileRoute}/change-password/${id}`, data);
    },
    [postQuery]
  );

  const getUserHasAccess = useCallback(() => {
    return getQuery(`${profileRoute}/has-any-client-access`);
  }, [getQuery]);

  return {
    postChangePassword,
    getUserHasAccess,
  };
};
